import http from "../httpService";
import {getBaseUrl} from "../../config";

export const submitConsultationReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/consultation_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/consultation_report?${paginate}`,
    data
  );
};

export const submitServiceReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/service_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/service_report?${paginate}`,
    data
  );
};

export const submitWorkReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/work_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/work_report?${paginate}`,
    data
  );
};

export const submitDailyWorkReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/daily_work_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/daily_work_report?${paginate}`,
    data
  );
};